<template>
    <div>
        <InputField
            type="text" 
            name="width" 
            label="Width" 
            v-model="constraints.custom_data.carousel.width" 
            @error="fieldError"
            :rules="{required: true, default: '1024'}"
        />

        <InputField
            type="text" 
            name="height" 
            label="Height" 
            v-model="constraints.custom_data.carousel.height" 
            @error="fieldError"
            :rules="{required: true, default: '480'}"
        />

        <InputField
            type="number" 
            name="interval" 
            label="Interval" 
            description="Interval in which images will change"
            v-model="constraints.custom_data.carousel.interval" 
            @error="fieldError"
            :rules="{required: true, default: 0}"
        />

        <InputField
            type="number" 
            name="interval" 
            label="Max images" 
            description="Maximum number of images allowed"
            v-model.number="constraints.custom_data.carousel.max_images" 
            @error="fieldError"
            :rules="{required: true, default: 10, length: {min: 1, max: 10}}"
        />

        <b-form-group
            description=""
            label="Controls"
            label-for="controls"
            :label-cols="3"
            :horizontal="false">
                <c-switch class="mx-1" color="success" variant="pill" v-model="constraints.custom_data.carousel.controls"/>
        </b-form-group>

        <b-form-group
            description="User choose image from library"
            label="Choose from library"
            label-for="choose_from_library"
            :label-cols="4"
            :horizontal="true">
            <small v-if="!$store.getters.isIntegrationActive('protokol-media')">
                {{ $t("integrations.media.optionIsAvailableAfterActivation") }}
            </small>
            <c-switch class="mx-1" color="success" variant="pill" v-model="constraints.custom_data.carousel.chooseFromLibrary" @change="(e) => handleChange('libraryOptions', e)" v-else/>
        </b-form-group>

        <b-form-group
            v-if="libraries !== null && libraryOptions"
            label="Libraries"
            description="Allowed libraries that can be choosen from"
            label-for="libs"
            :label-cols="2"
            :horizontal="false">
            <v-select v-model="constraints.custom_data.carousel.libraries" label="name" :options="libraries" multiple :reduce="lib => lib.uuid" />
        </b-form-group>

        <b-form-group
            description="User choose image from device and it will be uploaded to library"
            label="Choose from device"
            label-for="choose_from_device"
            :label-cols="4"
            :horizontal="true">
            <small v-if="!$store.getters.isIntegrationActive('protokol-media')">
                {{ $t("integrations.media.optionIsAvailableAfterActivation") }}
            </small>
            <c-switch class="mx-1" color="success" variant="pill" v-model="constraints.custom_data.carousel.chooseFromDevice" @change="(e) => handleChange('deviceOptions', e)" v-else/>
        </b-form-group>

        <SelectField name="roles" label="Default library" description="Default library where files will be uploaded from this field" v-model="constraints.custom_data.carousel.defaultLibrary"
            :items="libraries"
            :reduce="(lib) => {return {value: lib.uuid, text: lib.name} }"
            :rules="{required:false}"

            v-if="libraries !== null && deviceOptions"
        />

        <b-form-group
            description="Provide external source to image"
            label="External source"
            label-for="external_source"
            :label-cols="4"
            :horizontal="true">
            <c-switch class="mx-1" color="success" variant="pill" v-model="constraints.custom_data.carousel.chooseExternalSource"  @change="(e) => handleChange('externalOptions', e)"/>
        </b-form-group>
    </div>
</template>
<script>
import { Switch as cSwitch } from '@coreui/vue'
import InputField from '@/components/form/Input'
import SelectField from "@/components/form/Select"
import VSelect from 'vue-select'

export default {
    components: {
        InputField,
        cSwitch,
        SelectField,
        VSelect
    },
    props: {
        value: {
            type: Object | String
        }
    },
    data: function() {
        return {
            errors: [],
            libraries: null,
            libraryOptions: false,
            deviceOptions: false,
            externalOptions: false
        }
    },
    watch: {
        'constraints.custom_data.carousel': {
            handler(nVal, oVal) {
                if (!nVal.chooseFromLibrary && !nVal.chooseFromDevice) {
                    this.constraints.custom_data.carousel.chooseExternalSource = true
                }
            },

            immediate: true,
            deep: true
        }
    },
    computed: {
        constraints() {
            let base = this.value

            base.custom_data.carousel = base.custom_data.carousel || {}

            return base;
        },

        externalSourceDisabled() {
            return !this.constraints.custom_data.carousel.chooseFromLibrary && !this.constraints.custom_data.carousel.chooseFromDevice
        }
    },
    methods: {
        save() {
            this.$emit('input', this.constraints)
        },

        fieldError(error) {
            let found = this.errors.find((i, e) => {
                return i.field == error.field
            })

            if (found === undefined) {
                this.errors.push(error)
            } else {
                this.errors.map(e => {
                    if (found.field == e.field)
                        e.error = error.error
                })
            }
        },

        handleChange(key, val) {
            this[key] = val
        }
    },
    
    mounted() {
        this.$store.dispatch('fetchLibraries').then(libs => {
            this.libraries = libs
        })
    }
    
}
</script>